import React, { useEffect, useState } from "react";
import { Form, Select } from "antd";
import { userListAction } from "../../../actions/admin";
import { useDispatch, useSelector } from "react-redux";
import {
  leaderUserListAction,
  leaderUserListSpecificOrgAction,
} from "../../../actions/user";

// Define interface for pagination params
interface PaginationParams {
  page?: number;
  limit?: number;
}

interface ListingInitialData {
  leaderId?: string;
  dataToSet?: any;
  onSelect?: (userId: string | number) => void;
  selectedOrgId?: number;
  roleType?: number;
  type?: any;
}

const { Option } = Select;

const UserLeaderListing: React.FC<ListingInitialData> = ({
  leaderId,
  dataToSet,
  onSelect,
  selectedOrgId,
  roleType,
  type,
}) => {
  const [data, setData] = useState<any[]>([]);
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState<boolean>(true);
  const user = useSelector((state: any) => state?.Auth?.user);
  const roleId = user?.user?.roleId;
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 7,
    total: 0,
    totalPages: 0,
  });

  // Fetches the list of users with optional query parameters
  const fetchUserList = (params: PaginationParams = {}, appendData = false) => {
    setLoading(true);
    if (roleId === 1) {
      dispatch(
        userListAction({ ...params, roleId: roleType }, (resp: any) => {
          setLoading(false);
          if (resp?.status === 200) {
            // Append new data to existing data if appendData is true, safely handling undefined
            setData((prevData) => {
              const newData = resp?.data || [];
              return appendData ? [...prevData, ...newData] : newData;
            });
            // Update the pagination state with the response pagination data
            setPagination((prev) => ({
              current: resp?.pagination?.currentPage || prev.current,
              total: resp?.pagination?.totalItems || prev.total,
              pageSize: resp?.pagination?.pageSize || prev.pageSize,
              totalPages: resp?.pagination?.totalPages || prev.totalPages,
            }));
          }
        })
      );
    } else if (type === "dataElementAssignment") {
      dispatch(
        leaderUserListSpecificOrgAction(
          { ...params, id: selectedOrgId },
          (resp: any) => {
            setLoading(false);
            if (resp?.status === 200) {
              // Append new data to existing data if appendData is true, safely handling undefined
              setData((prevData) => {
                const newData = resp?.data || [];
                return appendData ? [...prevData, ...newData] : newData;
              });
              // Update the pagination state with the response pagination data
              setPagination((prev) => ({
                current: resp?.pagination?.currentPage || prev.current,
                total: resp?.pagination?.totalItems || prev.total,
                pageSize: resp?.pagination?.pageSize || prev.pageSize,
                totalPages: resp?.pagination?.totalPages || prev.totalPages,
              }));
            }
          }
        )
      );
    } else {
      dispatch(
        leaderUserListAction(params, (resp: any) => {
          setLoading(false);
          if (resp?.status === 200) {
            // Append new data to existing data if appendData is true, safely handling undefined
            setData((prevData) => {
              const newData = resp?.data || [];
              return appendData ? [...prevData, ...newData] : newData;
            });
            // Update the pagination state with the response pagination data
            setPagination((prev) => ({
              current: resp?.pagination?.currentPage || prev.current,
              total: resp?.pagination?.totalItems || prev.total,
              pageSize: resp?.pagination?.pageSize || prev.pageSize,
              totalPages: resp?.pagination?.totalPages || prev.totalPages,
            }));
          }
        })
      );
    }
  };

  // Load initial data
  useEffect(() => {
    if (selectedOrgId || roleType) {
      // Reset pagination and data when selectedOrgId changes
      setPagination({
        current: 1,
        pageSize: 7,
        total: 0,
        totalPages: 0,
      });
      setData([]);
      fetchUserList({
        page: 1,
        limit: 7,
      });
    }
  }, [selectedOrgId, roleType]);

  // Handle onPopupScroll event for the Select component
  const handleSelectScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { target } = e;
    if (
      target instanceof HTMLElement &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight - 20 &&
      !loading &&
      pagination.current < pagination.totalPages
    ) {
      // Load next page and append data
      const nextPage = pagination.current + 1;
      fetchUserList(
        {
          page: nextPage,
          limit: pagination.pageSize,
        },
        true
      ); // Pass true to append data
    }
  };

  // Handle selection change
  const handleSelectChange = (value: string | number) => {
    // Pass the selected user ID to the parent component
    if (onSelect) {
      onSelect(value);
    }
  };

  return (
    <div className="mb-none">
      <Form.Item
        name="userId"
        rules={[
          {
            required: true,
            message: "Please select a user",
          },
        ]}
      >
        <Select
          placeholder="User Name"
          className="input-main-col focus:bg-transparent rounded-[5px] p-[8px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto"
          onPopupScroll={handleSelectScroll}
          notFoundContent={loading ? "Loading..." : "No data found"}
          listHeight={200}
          allowClear
          onChange={handleSelectChange}
          dropdownStyle={{ backgroundColor: "#013351" }}
        >
          {leaderId && (
            <Option key={leaderId} value={leaderId}>
              Me
            </Option>
          )}
          {data?.map((user) => (
            <Option
              key={user?.id}
              value={user?.id}
              style={{
                backgroundColor: "#013351",
                border: "none",
              }}
            >
              <div
                style={{ display: "flex", flexDirection: "row", gap: "2px" }}
              >
                {user?.name}
              </div>
            </Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
};

export default UserLeaderListing;
